module.exports = __webpack_public_path__ + "static/media/TheSecretWorldofBriarRose_jacket.298b2b04.jpg";